import React from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import GearLoader from './GearLoader';
import './GlobalTruckLoader.css';

const GlobalTruckLoader = () => {
  const { isAnyLoading, getCurrentLoadingMessage } = useLoading();

  if (!isAnyLoading) {
    return null;
  }

  return (
    <div className="global-truck-loader-overlay">
      <div className="global-truck-loader-container">
        <GearLoader text={getCurrentLoadingMessage()} />
      </div>
    </div>
  );
};

export default GlobalTruckLoader;
